//We are rendering on Client Side only components that can be reused as content on Posts/Pages; otherwise we are using Server Side Rendering directly in WordPress templates; Reusable server-side-rendered components would require to be globally scoped in Timber which is slower (unless Cache is enabled)

import posts from './render/posts';
import team from './render/team';
// import productsGrid from './render/productsGrid';
// import faq from './render/faq';

export let Render = {
    posts,
    team,
}